function getArrOfProperties(input) {
  let finalArr = [];

  if (Array.isArray(input)) {
    for (let item of input) {
      const processedItem = getArrOfProperties(item);

      finalArr = [...finalArr, ...processedItem];
    }
  } else if (input && typeof input === "object") {
    for (let item of Object.values(input)) {
      const processedItem = getArrOfProperties(item);

      finalArr = [...processedItem, ...finalArr];
    }
  } else if (input) {
    finalArr.push(String(input).toLowerCase());
  }

  return finalArr;
}

export function getObjectStringValues(obj) {
  if (!obj) return null;

  let objectArr = Object.entries({ ...obj });
  let finalArr = [];

  for (let [key, value] of objectArr) {
    finalArr.push([key, getArrOfProperties(value)]);
  }

  return finalArr;
}

export function normalizeQuery(strg) {
  return strg
    .split(" ")
    .filter((e) => e)
    .map((e) => e.toLowerCase());
}

export function convertLetterToNumber(str) {
  const start = 96;
  const len = str.length;
  const out = [...str.toLowerCase()].reduce((out, char, pos) => {
    const val = char.charCodeAt(0) - start;
    const pow = Math.pow(26, len - pos - 1);
    return out + val * pow;
  }, 0);
  return out;
}

export function getInitialsOfName(name = "X", surname = "X") {
  const letterName = name[0].toUpperCase();
  const letterSurname = surname[0].toUpperCase();

  return [letterName, letterSurname];
}

export function getImageAspectRatio(imageUrl, callback) {
  const img = new Image();

  img.onload = function () {
    const aspectRatio = this.naturalWidth / this.naturalHeight;
    callback(aspectRatio);
  };

  img.src = imageUrl;
}

export const getHourFromTimestamp = (timestamp) => {
  const date = new Date(timestamp);

  const processNumber = (num) => (num < 10 ? `0${num}` : num);
  return `${processNumber(date.getHours())}:${processNumber(
    date.getMinutes()
  )}`;
};
